import APIService from '@/api'

export default class APICustomerPhoneNote extends APIService{

    constructor(){
        super('customerphonenotes')
    }

    async getAll(customerId) {
        var response = await this.AxiosInstance
            .get(this.ApiUrl, { params: { customerId: customerId } })
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }

    create(item, customerId) {
        return this.AxiosInstance.post(this.ApiUrl, item, { params: { } });
    }

    update(item, customerId) {
        return this.AxiosInstance.put(this.ApiUrl, item, { params: { } });
    }

    delete(item) {
        return this.AxiosInstance.delete(this.ApiUrl, { params: { id: item.ID } });
    }
}


// WEBPACK FOOTER //
// ./src/api/customerphonenote.js